import {
  CHANGE_SP_CASE_PAGE_LOADING,
  CHANGE_SP_CASE,
  CHANGE_CHAT,
  CHANGE_CONFIRM,
  CHANGE_FILE,
  CHANGE_PING,
  CHANGE_MORE_INFOS_VISIBLE,
  CHANGE_MORE_INFOS,
  CHANGE_MORE_INFOS_COMMENT,
  SAVE_MORE_INFOS,
  CHANGE_CHECKOUT,
  CHANGE_ARCHIVE_REASONS,
  CHANGE_VIEWED_OPPOSITE_PART
} from './actions'

export default function (state = {
  loading: false,
  ping: true,
  spCase: {
    chat: [],
    client: {},
    lawyer: {},
    company: {},
    group: {},
    classifiers: []
  },
  confirm: {
    message: {},
    file: {},
  },
  moreInfos: {
    visible: false
  },
  attachment: null,
  checkout: false,
  archiveReasons: []
}, action) {
  switch (action.type) {
    case CHANGE_SP_CASE_PAGE_LOADING:
      return { ...state, loading: action.payload }
    case CHANGE_SP_CASE:
      return { ...state, spCase: action.payload }
    case CHANGE_CHAT:
      return {
        ...state,
        spCase: {
          ...state.spCase,
          chat: [
            ...state.spCase.chat.filter((item, index) => {
              if (item.allowed) {
                delete item.allowed
              }
              return item
            }),
            action.payload
          ],
          status: action.payload.status
        },
        confirm: {
          visible: false,
          message: {},
        }
      }
    case CHANGE_CONFIRM:
      return { ...state, confirm: action.payload }
    case CHANGE_FILE:
      return {
        ...state,
        confirm: {
          ...state.confirm,
          file: action.payload
        }
      }
    case CHANGE_PING:
      return { ...state, ping: action.payload }
    case CHANGE_MORE_INFOS_VISIBLE:
      return { ...state, moreInfos: { visible: action.payload } }
    case CHANGE_MORE_INFOS:
      return {
        ...state,
        spCase: {
          ...state.spCase,
          [action.payload.field]: action.payload.value
        }
      }
    case CHANGE_MORE_INFOS_COMMENT:
      return {
        ...state,
        spCase: {
          ...state.spCase,
          comment: action.payload
        }
      }
    case CHANGE_CHECKOUT:
      return {
        ...state,
        confirm: {
          visible: false,
          message: {},
        },
        checkout: action.payload
      }
    case CHANGE_ARCHIVE_REASONS:
      return {
        ...state,
        archiveReasons: action.payload
      }
    case CHANGE_VIEWED_OPPOSITE_PART:
      return {
        ...state,
        spCase: {
          ...state.spCase,
          viewedOppositePart: action.payload
        }
      }
    default:
      return state
  }
}
